<template>
  <div
    class="relative w-full"
    :class="[roundedClass, selected ? 'bg-shade-200' : 'bg-white']"
  >
    <div
      class="z-20 flex w-full flex-col justify-end overflow-hidden p-4 align-middle transition-colors hover:border-gray-550"
    >
      <slot name="badge"></slot>
      <div
        class="flex w-full items-center gap-3 rounded-md border bg-white"
        :class="selected ? 'border-black' : 'border-[#E5E5E5]'"
      >
        <RadioItem
          class="p-3"
          :value="value"
          :disabled="disabled"
          :model-value="modelValue"
          @update:model-value="onChange"
        >
          <template #label>
            <div class="flex items-center gap-2">
              <span v-dompurify-html="label" />
              <slot name="info-modal"></slot>
            </div>
          </template>

          <template #price>
            <slot name="price"></slot>
          </template>

          <template #description>
            <slot name="description"></slot>
          </template>
        </RadioItem>
      </div>

      <div
        ref="subscription-content"
        :style="{ height: selected ? 'fit-content' : 0 }"
        class="z-10 flex flex-col rounded-b-lg transition-height ease-in-out"
      >
        <div class="flex flex-col gap-4">
          <!-- @slot Slot for the content of the drawer -->
          <slot :selected="selected"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts" generic="Item extends { label: string; value: any }">
type Props = {
  modelValue?: string | number
  value?: Item['value']
  label?: Item['label']
  name?: string
  roundedClass?: string
  disabled?: boolean
}
const props = withDefaults(defineProps<Props>(), {
  modelValue: undefined,
  value: undefined,
  label: undefined,
  name: '',
  roundedClass: 'rounded-lg',
  disabled: false,
})

const selected = computed(() => props.value === props.modelValue)

const emit = defineEmits(['update:model-value'])

const onChange = (value?: string | number) => emit('update:model-value', value)
</script>
